// Every task must carry the "Task created by <user>" stamp so EMR staff can
// tell who created it (ENG-2950). Template notes go above the stamp, never in
// place of it.
export const taskCreatedByStamp = () => `Task created by ${localStorage.m8_name}`;

export const buildTaskTemplateNotes = (templateNotes) => {
  const stamp = taskCreatedByStamp();
  const trimmedNotes = (templateNotes || '').trim();
  return trimmedNotes ? `${trimmedNotes}\n\n${stamp}` : stamp;
};
